import { Controller } from "@hotwired/stimulus"

// Generic navigation controller with smooth scrolling
// Used by both product and support pages
// Bootstrap 5.3 scrollspy handles the active state tracking automatically
export default class extends Controller {
  static targets = ["link"]

  connect() {
    // Add click handlers for smooth scrolling
    this.linkTargets.forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this))
    })
  }

  disconnect() {
    this.linkTargets.forEach(link => {
      link.removeEventListener('click', this.handleClick.bind(this))
    })
  }

  handleClick(event) {
    const link = event.currentTarget
    const href = link.getAttribute('href')

    // Only handle hash links
    if (!href || !href.startsWith('#')) {
      return
    }

    const targetId = href.substring(1)
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      event.preventDefault()

      // Smooth scroll to the target with offset for sticky nav
      const offset = 100
      const elementPosition = targetElement.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }
}

